var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tree-section-container h-100"},[_c('div',[_c('el-tree',{attrs:{"data":_vm.menuTree,"default-expanded-keys":[0]},on:{"node-click":_vm.handleNodeClick}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }